const sections = [
  {
    title: 'Incluso no pacote:',
    variant: 'included',
    icon: 'bi-check2',
    items: [
      'Espaço do Treinamento',
      'Alimentação durante o treinamento (almoço, coffee break manhã e tarde)',
      'Produtos para Prática',
      'Material de Apoio',
      'Kit Boas Vindas',
    ],
  },
  {
    title: 'O que não está incluso:',
    variant: 'excluded',
    icon: 'bi-x',
    items: ['Translado até SP', 'Hospedagem', 'Jantar'],
  },
  {
    title: 'Responsabilidades do Franqueado:',
    variant: 'neutral',
    icon: 'bi-dot',
    wide: true,
    items: [
      'Realizar a compra de passagem e hospedagem do participante.',
      'A hospedagem fica a critério do franqueado. Sugerimos que seja próximo ao local do evento. (Para apoio, disponibilizaremos futuramente sugestões de hospedagem, mas fique à vontade para reservar onde preferir).',
    ],
  },
  {
    title: 'Informações adicionais:',
    variant: 'neutral',
    icon: 'bi-info-circle',
    wide: true,
    items: [
      'Como nossa programação começa cedo, sugerimos que os participantes cheguem no dia anterior e retornem após as 20h.',
    ],
  },
];

export const Information = ({ t }) => {
  return (
    <>
      <h2 className='site-title mb-4'>{t('event.description.title')}</h2>
      <div className='bento'>
        {sections.map((section) => (
          <div
            key={section.title}
            className={`bento__tile ${section.wide ? 'bento__tile--wide' : ''}`}
          >
            <h3 className='site-subtitle mb-0'>{section.title}</h3>
            <ul className={`info-list info-list--${section.variant}`}>
              {section.items.map((item) => (
                <li key={item}>
                  <i
                    className={`bi ${section.icon}`}
                    aria-hidden='true'
                  />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </>
  );
};
